import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { ErrorToast } from 'services/toasterService';

export default function useAddProfessionalExperienceDetails(
  closeModal,
  iscloseModalTrue,
  reset
) {
  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(
        apiEndPoints.EMPLOYEE_PROFESSIONAL_EXPERIENCE,
        data
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        if (iscloseModalTrue) {
          closeModal();
        }
        reset();
        queryClient.invalidateQueries('get-employee-professional-info');
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
